module.exports = __webpack_public_path__ + "img/LinkedIn-WhiteBorder.430cf983.png";